import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

import IconButton from "features/components/IconButton";

interface Props {
  images: { ID: string; url: string }[];
  selectedImageId?: string;
  setSelectedImageId: (id: string) => void;
}

const ImageButtons = ({
  images,
  selectedImageId,
  setSelectedImageId,
}: Props) => (
  <div className="flex gap-2" onClick={(e) => e.stopPropagation()}>
    <IconButton
      data-testid="previous-photo"
      size="small"
      className="!bg-white !rounded-md shadow-md outline outline-2 outline-gray-50"
      style={{ outlineColor: "#f3f4f6" }}
      onClick={() => {
        const currentIndex = images.findIndex(
          ({ ID }) => ID === selectedImageId
        );
        const previousIndex =
          (currentIndex - 1 + images.length) % images.length;
        setSelectedImageId(images[previousIndex].ID);
      }}
      disabled={images.findIndex(({ ID }) => ID === selectedImageId) === 0}
    >
      <ExpandMoreOutlinedIcon className="rotate-90" />
    </IconButton>
    <IconButton
      data-testid="next-photo"
      size="small"
      className="!bg-white !rounded-md shadow-md outline outline-2 outline-gray-50"
      style={{ outlineColor: "#E0E0E0" }}
      onClick={() => {
        const currentIndex = images.findIndex(
          ({ ID }) => ID === selectedImageId
        );
        const nextIndex = (currentIndex + 1) % images.length;
        setSelectedImageId(images[nextIndex].ID);
      }}
      disabled={
        images.findIndex(({ ID }) => ID === selectedImageId) ===
        images.length - 1
      }
    >
      <ExpandMoreOutlinedIcon className="rotate-270" />
    </IconButton>
  </div>
);
export default ImageButtons;
